// extracted by mini-css-extract-plugin
export var contents = "style-module--contents--5447b";
export var layout = "style-module--layout--c061a";